import { createFileRoute } from "@tanstack/react-router";
import { FormBuilderPanel } from "@/features/form-editor/components/form-builder/form-builder-panel";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/ticketTypes/$ticketTypeId/form/",
)({
	component: FormBuilderPanel,
});
